"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Formatter = void 0;
var ethers_1 = require("ethers");
var FormatterClass = /** @class */ (function () {
    function FormatterClass() {
    }
    FormatterClass.prototype.BigToSmall = function (value, decimals) {
        if (decimals === void 0) { decimals = 18; }
        return ethers_1.ethers.utils.formatUnits(value, decimals);
    };
    FormatterClass.prototype.SmallToBig = function (value, decimals) {
        if (decimals === void 0) { decimals = 18; }
        return ethers_1.ethers.utils.parseUnits(value, decimals);
    };
    return FormatterClass;
}());
exports.Formatter = new FormatterClass();
